import { render, staticRenderFns } from "./CoinIntroduction.vue?vue&type=template&id=31733be1&scoped=true"
import script from "./CoinIntroduction.vue?vue&type=script&lang=js"
export * from "./CoinIntroduction.vue?vue&type=script&lang=js"
import style0 from "./CoinIntroduction.vue?vue&type=style&index=0&id=31733be1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31733be1",
  null
  
)

export default component.exports